(function handleEntranceTray() {
  const storage = localStorage.getItem('entrance-tray');
  const tray = window.traps.store['entrance-tray'];

  if (tray && storage !== 'true') {
    setTimeout(() => {
      if (window.traps.store['cookies'].active) return;

      tray.activate();
      localStorage.setItem('entrance-tray', 'true');
    }, 10000);
  }
})();
